import { useV2ListQuestionnaireCalculationsForQuestionnaireQuery } from "@generated";
import type { Calculation } from "../types";

export const useCalculationsList = (questionnaireId: string) => {
  const { data, isLoading, isFetching, refetch } =
    useV2ListQuestionnaireCalculationsForQuestionnaireQuery(
      {
        questionnaireId: Number(questionnaireId),
        filter: { active: true },
        page: { size: 500 },
      },
      { refetchOnMountOrArgChange: true }
    );

  const rows: Calculation[] = (data?.data ?? []).map((c: any) => ({
    id: String(c.id),
    name: c.attributes?.name ?? "",
    slug: c.attributes?.slug ?? "",
    expression: c.attributes?.expression ?? "",
  }));

  return { rows, isLoading, isFetching, refetch };
};

export default useCalculationsList;
